import React from 'react';
import Icon from '../../../components/AppIcon';
import { TechnicalCapability } from '../types';

const TechnicalCapabilities: React.FC = () => {
  const capabilities: TechnicalCapability[] = [
    {
      id: '1',
      category: 'API Development',
      icon: 'Code',
      capabilities: [
        'RESTful API Design & Implementation',
        'GraphQL API Development',
        'WebSocket Real-Time APIs',
        'Webhook Integration & Management',
        'API Gateway Configuration',
        'Microservices Architecture'
      ]
    },
    {
      id: '2',
      category: 'Data Integration',
      icon: 'Database',
      capabilities: [
        'ETL Pipeline Development',
        'Data Transformation & Mapping',
        'Database Synchronization',
        'Legacy System Integration',
        'Cloud Data Migration',
        'Data Warehouse Connections'
      ]
    },
    {
      id: '3',
      category: 'Authentication & Security',
      icon: 'Lock',
      capabilities: [
        'OAuth 2.0 Implementation',
        'JWT Token Management',
        'API Key Generation & Rotation',
        'Rate Limiting & Throttling',
        'SSL/TLS Certificate Management',
        'Penetration Testing & Audits'
      ]
    },
    {
      id: '4',
      category: 'Monitoring & Analytics',
      icon: 'BarChart3',
      capabilities: [
        'Real-Time Performance Monitoring',
        'API Usage Analytics',
        'Error Tracking & Alerting',
        'Custom Dashboard Development',
        'SLA Compliance Reporting',
        'Predictive Maintenance'
      ]
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            Comprehensive Technical Capabilities
          </h2>
          <p className="text-lg text-text-secondary">
            Full-stack integration expertise covering every aspect of API development and management
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {capabilities.map((capability) => (
            <div 
              key={capability.id}
              className="bg-card p-8 rounded-lg border border-border hover:shadow-lg transition-all duration-fast"
            >
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={capability.icon} size={28} className="text-primary" />
                </div>
                <h3 className="text-2xl font-semibold text-text-primary">
                  {capability.category}
                </h3>
              </div>
              
              <ul className="space-y-3">
                {capability.capabilities.map((item, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <Icon name="CheckCircle2" size={20} className="text-success flex-shrink-0 mt-0.5" />
                    <span className="text-text-secondary">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnicalCapabilities;